<template>
  <div>
    <v-data-table
        :headers="tabla.headers"
        :items="items"
        :options.sync="tabla.options"
        :fixed-header="true"
        class="elevation-3"
        calculate-widths
        :no-data-text="$t('No hay datos')"
        :no-results-text="$t('No hay datos')"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.num_ticket }}</td>
          <td>{{ item.fecha_venta | moment('DD/MM/YYYY HH:mm') }}</td>
          <td>{{ item.descripcion }}</td>
          <td>{{ item.cliente }}</td>
          <td>{{ $t(item.tipo) }}</td>
          <td>{{ formas_pago[item.forma_pago] }}</td>
          <td>
            <span v-if="!show_sin_iva">{{ item.total_linea | money }}</span>
            <span v-if="show_sin_iva">{{ item.total_linea_sin_iva | money }}</span>
          </td>
          <td>{{ item.porcentaje_comision }}%</td>
          <td>
            <span v-if="!show_sin_iva">{{ item.total_comision | money }}</span>
            <span v-if="show_sin_iva">{{ item.total_comision_sin_iva | money }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>


<script>
export default {
  name: 'TablaComisionesEmpleadoDetalle',
  props: {
    show_sin_iva: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: []
    }
  },
  data: () => ({
    tabla: {
      headers: []
    },
    formas_pago: []
  }),

  mounted() {
    this.tabla.headers = [
      { text: this.$t('Ticket'), class: 'primary white--text', sortable: false },
      { text: this.$t('Fecha'), class: 'primary white--text', sortable: false },
      { text: this.$t('Concepto'), class: 'primary white--text', sortable: false },
      { text: this.$t('Cliente'), class: 'primary white--text', sortable: false },
      { text: this.$t('Tipo'), class: 'primary white--text', sortable: false },
      { text: this.$t('Forma de pago'), class: 'primary white--text', sortable: false },
      { text: this.$t('Importe'), class: 'primary white--text', sortable: false },
      { text: this.$t('%'), class: 'primary white--text', sortable: false },
      { text: this.$t('Comisión'), class: 'primary white--text', sortable: false}
    ]

    this.formas_pago = {
      '1': this.$t('Efectivo'),
      '2': this.$t('Tarjeta'),
      '3': this.$t('Vale'),
      '4': this.$t('Transferencia'),
      '5': this.$t('Financiera'),
      '6': this.$t('Mixto'),
      '7': this.$t('Paypal'),
      '8': this.$t('Online'),
      '9': this.$t('Bizum'),
      '10': this.$t('Tarjeta Regalo'),
      '11': this.$t('Tarjeta Fidelidad')
    }
  }
}
</script>
